import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { User } from '../../classess/user/user';
import { Role } from '../../classess/role/role';

import { GlobalFormats } from '../../classess/main/globalFormats';

import AnalystAdd from '../users/UserAddEdit';
import {
    LoadingSection, awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, settings, styles, handleResponseMessageAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { RoleUser } from '../../classess/role/roleUser';
import { AnalystService } from '../../services/analysts/AnalystService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Analysts';

export default function Analysts({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtUsersId = 'dtAnalysts';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: true, save: false });
    const isMount = useRef(false);

    const [analyst, setAnalyst] = useState({
        ...User?.getClass({}, false),
        passwordConfirm: '',
        roleId: '',
    });
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        typeModal: 1,
        languageObj: languageObj,
        dtUsersId: dtUsersId,
        dtUsersRowId: 0,
        roles: [Role?.class({}, false)],
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region analysts
    const analystAddGetAsync = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'analystAddGetAsync';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let roles = [];
            //#endregion variables
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region roles (get users)
            response = await AnalystService.getAnalystRoles({
                auth: modalObj?.auth,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            roles.push(response?.result?.role || {});
            //#endregion roles (get users)

            setAnalyst(prev => ({
                ...User?.getClass({}, false),
                createdUserId: auth?.user?.id,
                passwordConfirm: '',
                roleId: '',
            }));
            await awaitDelayAsync({ delayTime: timers?.twoNanoSeconds });

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 0,
                auth: auth,
                showModal: true,
                roles: roles,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const analystEditGetAsync = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'analystEditGetAsync';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let analyst = User?.getClass({}, false);
            let roles = [Role?.class({}, false)];
            let roleUser = RoleUser?.class({}, false);
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region user (get byid)
            response = await AnalystService.getById({
                auth: modalObj?.auth,
                id: id,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            analyst = !isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: response?.result?.user, subMethod: currentMethod })?.result &&
                !isUndNull({ data: response?.result?.user?.id, subMethod: currentMethod })?.result ?
                User?.getClass(response?.result.user, false) :
                {};

            roles = response?.result?.roles || [];
            roleUser = response?.result?.roleUser[0] || {};
            //#endregion user (get byid)

            //#region check data
            if (isUndNullEmp({ data: analyst, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }
            //#endregion check data

            setAnalyst(prev => ({
                ...analyst,
                passwordConfirm: '',
                roleId: roleUser.roleId,
            }));

            setModalObj(prev => ({
                ...prev,
                $: $,
                type: 1,
                auth: auth,
                dtUsersRowId: rowId,
                showModal: true,
                roles: roles,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const analystDeleteAsync = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'analystDeleteAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.user?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };
            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data(user)
                        preConfirmResponse = await AnalystService.deleteAsync({
                            auth: auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (user)

                        //#region delete datatable (user)
                        $(`#${dtUsersId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                        //#endregion delete datatable (user)
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swaltResult = await Swal.fire({ ...swalProperties });
            if (swaltResult?.isConfirmed && swaltResult?.value) {
                response = swaltResult?.value
            } else if (swaltResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion analysts

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let analysts = [];
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (users)
                response = await AnalystService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                analysts = response?.result?.analysts || [];
                //#endregion get data (users)

                //#region set datatable
                if (!isUndNullEmp({ data: analysts, subMethod: currentMethod })?.result &&
                    analysts.length > 0) {
                    response = setDataInDataTable({ data: analysts, subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtUsersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.email?.[languageObj?.id], width: '45%', },
                    { title: labels?.firstName?.[languageObj?.id], width: '25%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '25%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtUsersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            // let attribute = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtUsersId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtUsersId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            analystEditGetAsync({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            analystDeleteAsync({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let usersDt = [];
            //#endregion variables

            //#region process
            data.forEach((user) => {
                const modelUser = User?.getClass(user, false);
                const processButtons = [];
                usersDt.push([
                    modelUser.email,
                    modelUser.firstName,
                    modelUser.lastName,
                    getProcessButtons({
                        id: modelUser.id,
                        description: modelUser.email,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtUsersId}`)?.DataTable()?.rows?.add(usersDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.analysts?.analysts} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.analysts?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.analysts?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.analysts?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.analyst} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.analysts?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.user} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            className={process?.save ? `${controls?.buttons?.addEditDetails?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : `${controls?.buttons?.addEditDetails?.defaultClass}`}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.save}
                                                            onClick={(e) => analystAddGetAsync({ e: e, subMethod: controls?.buttons?.addEditDetails?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.save ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={controls?.icons?.addEditDetails?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtUsersId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <AnalystAdd modalObj={modalObj}
                    setModalObj={setModalObj}
                    user={analyst}
                    setUser={setAnalyst} />
            )}
        </div>
    )
}